import { useState } from 'react';
import { confirmSignIn, getCurrentUser } from 'aws-amplify/auth';
import { LoginLayout } from './components/LoginLayout';
import PasswordField from './components/PasswordField';
import PasswordVerification from './components/PasswordVerification';
import Button from "components/Button/Button";
import { checkThePassword } from 'constants/index';
import Spinner from 'components/Spinner/Spinner';

const MyRequireNewPassword = ({ onNavigate }) => {
  const [error, setError] = useState('');
  const [password, setPassword] = useState('');
  const [passwordCheck, setPasswordCheck] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSendPass = async (ev) => {
    ev.preventDefault();
    if (password !== passwordCheck) {
      setError('Your passwords do not match each other');
      return;
    }
    setError('');
    try {
      await confirmSignIn({ challengeResponse: password });

      // Custom side-effect: confirm email after password change
      try {
        const { username } = await getCurrentUser();
        if (username) {
          await fetch('/api/confirm-email', {
            method: 'POST',
            body: JSON.stringify({ username }),
          });
        }
      } catch (_) {
        // Non-critical — don't block the flow
      }

      setLoading(true);
      window.location.reload();
    } catch (err) {
      setError(err.message || 'An error occurred');
    }
  };

  const passwordChecks = checkThePassword(password);
  const isPasswordValid = Object.values(passwordChecks).every(Boolean);

  if (loading) {
    return <Spinner />;
  }

  return (
    <LoginLayout title={"Enter New Password"} errorMessage={error}>
      <form className="relative space-y-6 pt-4 pb-8 px-8" onSubmit={handleSendPass}>
        <PasswordField
          defaulValue={''}
          onChange={(ev) => {
            setError('');
            setPassword(ev.target.value);
          }}
          id="password"
          name="password"
          label="New Password"
        />
        <PasswordField
          defaulValue={''}
          onChange={(ev) => {
            setError('');
            setPasswordCheck(ev.target.value);
          }}
          id="password-check"
          name="password-check"
          label="Confirm Your Password"
        />

        <PasswordVerification
          password={password || ''}
          areEqual={password === passwordCheck && password !== '' && passwordCheck !== ''}
        />

        <Button
          type="submit"
          variant="primary"
          size="lg"
          isFullWidth={true}
          isTextCenter={true}
          loading={false}
          disabled={!isPasswordValid || password !== passwordCheck}
        >
          Save the password
        </Button>
        <div className='flex justify-center'>
          <button
            type='button'
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            onClick={() => onNavigate('signIn')}
          >
            Back to Log In
          </button>
        </div>
      </form>
    </LoginLayout>
  );
};

export default MyRequireNewPassword;
